import { createRouter, createWebHashHistory } from 'vue-router'
import Search from '../views/SearchView.vue'
import Unsubscribed from '../views/UnsubscribedView.vue'
import Subscribed from '../views/SubscribedActive.View.vue'

const routes = [
  {
    path: '/',
    name: 'search',
    component: Search
  },
  {
    path: '/:id',
    name: 'searchtwo',
    component: Search
  },
  {
    path: '/inactive',
    name: 'unsubscribed',
    component: Unsubscribed
  },
  {
    path: '/active',
    name: 'active',
    component: Subscribed
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
